import React from "react";
import { Avatar, Typography, Stack } from "@mui/material";

type StatCardProps = {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  color: string;
  onClick?: () => void;
};

export const StatCard = ({
  title,
  value,
  icon,
  color,
  onClick,
}: StatCardProps) => (
  <Stack
    spacing={1}
    alignItems="center"
    textAlign="center"
    flex={1}
    onClick={onClick}
    role={onClick ? "button" : undefined}
    tabIndex={onClick ? 0 : undefined}
    onKeyDown={(e) => {
      if (!onClick) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick();
      }
    }}
    sx={
      onClick
        ? {
            cursor: "pointer",
            borderRadius: 2,
            p: 1,
            userSelect: "none",
            "&:hover": {
              backgroundColor: (theme) => theme.palette.action.hover,
            },
            "&:focus-visible": {
              outline: "2px solid",
              outlineColor: (theme) => theme.palette.primary.main,
              outlineOffset: 2,
            },
          }
        : undefined
    }
  >
    <Avatar sx={{ bgcolor: color, width: 48, height: 48 }}>{icon}</Avatar>
    <Typography variant="subtitle2" color="text.secondary">
      {title}
    </Typography>
    <Typography variant="h5" fontWeight={700}>
      {value}
    </Typography>
  </Stack>
);
